$(document).on('turbo:load', function() {
  const modal = $("#new-user-acceptance-modal");
  const marketingCheckbox = $("#user_subscribed_to_marketing_emails_tos_pp_202603");

  if (modal.length) {
    const code = modal.attr("data-code");
    const featureCodes = JSON.parse(modal.attr("data-feature-codes") ?? null);
    const dismissable = modal.attr("data-dismissable") === "true";

    modal.modal({ show: true, backdrop: dismissable ? true : 'static', keyboard: dismissable });

    switch (code) {
      case 'new_features_carousel':
      case 'loomly_ai_features_carousel':
        window.trackPicoUserAction('new_features_carousel_displayed',
          {
            feature_codes: featureCodes?.join(",")
          }
        );
        break;
      case 'tos_pp_202603':
        window.trackPicoUserAction('terms_of_service_modal_displayed', { terms_of_service_version: code });
        break;
      default:
        break;
    }

    let acknowledged = false;

    if (dismissable) {
      modal.on('hide.bs.modal', e => {
        if (!acknowledged) {
          e.preventDefault();
          acknowledge();
        }
      });
    }

    function acknowledge(redirectTo = null) {
      const marketingData = code === "tos_pp_202603" && marketingCheckbox.length ? { subscribed_to_marketing_emails: marketingCheckbox.is(":checked") } : {};

      $.ajax({
        url: "/user_acceptances",
        type: "POST",
        data: { code, feature_codes: featureCodes, ...marketingData },
        success: data => {
          acknowledged = true;
          modal.on("hidden.bs.modal", () => modal.remove());
          if (redirectTo) {
            window.location.href = redirectTo;
          } else {
            modal.modal("hide");
          }

          switch (code) {
            case 'new_features_carousel':
            case 'loomly_ai_features_carousel':
              window.trackPicoUserAction('new_features_carousel_dismissed',
                {
                  feature_codes: featureCodes?.join(",")
                }
              );
              break;
            case 'tos_pp_202603':
              window.trackPicoUserAction('terms_of_service_modal_accepted', { terms_of_service_version: code });
              break;
            default:
              break;
          }
        },
        error: (jqXHR) => {
          const errorMessage = (jqXHR.responseJSON?.errors && jqXHR.responseJSON?.errors.join(", ")) || jqXHR.responseText;
          alert(`An error occurred. Please try again. The response was: ${errorMessage}`);
        }
      });
    }

    modal.find(".accept-button").on("click", e => {
      e.preventDefault();
      acknowledge($(e.currentTarget).data("redirect-to"));
    });

    const carousel = $('#new-user-acceptance-modal-carousel');

    if (carousel.length) {

      const inner = carousel.children('.carousel-inner');
      const footer = carousel.children('.carousel-footer');
      const leftControl = footer.children('.left');
      const rightControl = footer.children('.right');

      const isLoomlyAiCarousel = code === 'loomly_ai_features_carousel';
      const lastSlideLabel = isLoomlyAiCarousel ? "Let's go!" : 'Got it!';
      const prevLabel = isLoomlyAiCarousel ? 'Previous' : 'Back';

      function checkitem(e) {
        const totalItems = inner.children('.item').length;
        const target = e && e.relatedTarget ? $(e.relatedTarget) : inner.children('.item.active');
        const isFirstItem = target.is(':first-child');
        const isLastItem = target.is(':last-child');

        if (isLoomlyAiCarousel) {
          leftControl.css('visibility', isFirstItem || totalItems === 1 ? 'hidden' : 'visible');
          rightControl.text(isLastItem || totalItems === 1 ? lastSlideLabel : 'Next');
        } else if (totalItems === 1) {
          leftControl.hide();
          rightControl.text(lastSlideLabel);
        } else if (isFirstItem) {
          leftControl.hide();
          rightControl.text('Next');
        } else if (isLastItem) {
          leftControl.show();
          rightControl.text(lastSlideLabel);
        } else {
          leftControl.text(prevLabel);
          leftControl.show();
          rightControl.text('Next');
        }
      }

      rightControl.on('click', e => {
        if (inner.children('.item:last').hasClass('active')) {
          e.preventDefault();
          acknowledge();
        }
      });

      carousel.on('slide slide.bs.carousel slid slid.bs.carousel', '', checkitem);

      checkitem();
    }
  }

  const flash = $("#new-user-acceptance-flash");

  if (flash.length) {
    const code = flash.attr("data-code");

    switch (code) {
      case "price_change_202503":
        window.trackPicoUserAction('repackaging_banner_displayed', {});
        break;
      case "bounced_repack_email_202505":
        window.trackPicoUserAction('repackaging_bounced_email_banner_displayed', {});
        break;
      default:
        break;
    }

    flash.find(".accept-button").on("click", e => {
      $.ajax({
        url: "/user_acceptances",
        type: "POST",
        data: { code },
        success: data => {
          flash.hide();

          switch (code) {
            case "price_change_202503":
              window.trackPicoUserAction('repackaging_banner_accepted', {});
              break;
            case "bounced_repack_email_202505":
              window.trackPicoUserAction('repackaging_bounced_email_banner_accepted', {});
              break;
            default:
              break;
          }
        },
        error: (jqXHR) => {
          const errorMessage = (jqXHR.responseJSON?.errors && jqXHR.responseJSON?.errors.join(", ")) || jqXHR.responseText;
          alert(`An error occurred. Please try again. The response was: ${errorMessage}`);
        }
      });
    });
  }
});
